import { baseApi } from '@/services/index'
import { ApplicationException, PaginatedResults } from '@/types/unlock'

export const applicationExceptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listApplicationExceptionsByApplication: builder.query<
      PaginatedResults<ApplicationException[]>,
      {
        applicationUUID: string
        page?: number
        pageSize?: number
        state?: string
        type?: string
      }
    >({
      query: ({ applicationUUID, page, pageSize, state, type }) => {
        return {
          url: `v2/applications/${applicationUUID}/application-exceptions/`,
          method: 'GET',
          params: {
            page: page,
            page_size: pageSize,
            state: state,
            type: type,
          },
        }
      },
      providesTags: ['AutomatedApplicationExceptions'],
    }),
    computeAutomatedApplicationExceptionsByApplication: builder.query<
      ApplicationException[],
      {
        applicationUUID: string
      }
    >({
      query: ({ applicationUUID }) => {
        return {
          url: `v2/applications/${applicationUUID}/application-exceptions/automated-exceptions/`,
          method: 'POST',
        }
      },
      providesTags: ['AutomatedApplicationExceptions'],
    }),
    updateApplicationExceptions: builder.mutation<
      void,
      {
        applicationUUID: string
        exceptions: Array<{
          application: number
          exception_type: string
        }>
      }
    >({
      query: ({ applicationUUID, exceptions }) => {
        return {
          url: `v2/applications/${applicationUUID}/application-exceptions/update-exceptions/`,
          method: 'PATCH',
          body: { application_exceptions: exceptions },
        }
      },
      invalidatesTags: ['ApplicationExceptions', 'AutomatedApplicationExceptions', 'Escalations'],
    }),
    computeAutomatedApplicationFlags: builder.query<
      ApplicationException[],
      { applicationUUID: string }
    >({
      query: ({ applicationUUID }) => {
        return {
          url: `v2/applications/${applicationUUID}/application-exceptions/automated-flags/`,
          method: 'POST',
        }
      },
      providesTags: ['AutomatedApplicationExceptions'],
    }),
  }),
})

export const {
  useLazyListApplicationExceptionsByApplicationQuery,
  useComputeAutomatedApplicationExceptionsByApplicationQuery,
  useLazyComputeAutomatedApplicationExceptionsByApplicationQuery,
  useUpdateApplicationExceptionsMutation,
  useComputeAutomatedApplicationFlagsQuery,
} = applicationExceptionApi
